import {Controller} from "stimulus"
import {buildCdMonthlyReportUrl} from "../helpers/cd_monthly_report_url"

/**
 * Controls the Community Development monthly report page.
 *
 * Instead of auto-navigating when dropdowns change, this controller
 * updates the "Render Report" button to load the report into a
 * turbo_frame and keeps the PDF download link in sync.
 */
export default class extends Controller {

    static get targets() {
        return ['renderButton', 'pdfLink']
    }

    connect() {
        this.updatePdfLink(this.jurisdictionCheckboxes())
    }

    selectionChanged() {
        this.updatePdfLink(this.jurisdictionCheckboxes())
    }

    jurisdictionCheckboxes() {
        return document.querySelectorAll('[data-target="cd-jurisdiction-multi-select.checkbox"]')
    }

    renderReport() {
        const checkboxes = this.jurisdictionCheckboxes()
        const baseUrl = buildCdMonthlyReportUrl(checkboxes)
        const contentUrl = baseUrl.replace('/reports/cd/monthly', '/reports/cd/monthly/content')

        const frame = document.getElementById('cd_report_content')
        if (frame) {
            frame.innerHTML = '<div class="flex items-center justify-center p-12 text-gray-400"><p>Loading report&hellip;</p></div>'
            frame.src = contentUrl
        }

        this.updatePdfLink(checkboxes)
    }

    updatePdfLink(checkboxes) {
        if (!this.hasPdfLinkTarget) return
        const baseUrl = buildCdMonthlyReportUrl(checkboxes)
        const pdfUrl = baseUrl.replace('/reports/cd/monthly?', '/reports/cd/monthly.pdf?')
        this.pdfLinkTarget.href = pdfUrl
    }
}
